import React, { Component } from 'react';
import { Col, Container, Row, Badge, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, UncontrolledDropdown } from 'reactstrap';
import PropTypes from 'prop-types';
import '../../css/container/DefaultFooter.css';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultFooter extends Component {
  render() {

    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
     
          <div className="copyright sm-text-center">
            <p className="small no-margin  copyright-upper">
              <span className="hint-text">Copyright © 2019 </span>
              <span>by Tricor Roots Consulting (471614-P). All rights reserved</span>
              <span className="sm-block"><a href="#" className="ml-2 mr-2 text-link ">Terms of use</a> <span className="muted">|</span> <a href="#" className="ml-2 text-link ">Privacy Policy</a></span>
            </p>
 
            <div className="clearfix"></div>
          </div>
      
      </React.Fragment>
    );
  }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;
